import { render, staticRenderFns } from "./StocksTable.vue?vue&type=template&id=2228d8c8&scoped=true&"
import script from "./StocksTable.vue?vue&type=script&lang=js&"
export * from "./StocksTable.vue?vue&type=script&lang=js&"
import style0 from "./StocksTable.vue?vue&type=style&index=0&id=2228d8c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228d8c8",
  null
  
)

export default component.exports